export const projects = [
  {
    title: "Messenger App",
    subtitle: "MERN Stack",
    description:
      "React custom hooks for data fetching. Authentication and Authorization with JWT. Real-time messaging with Socket.io. Online user status (Socket.io and React Context). Error handling both on the server and on the client.",
    image: "https://i.ibb.co/yqvW2qf/Screenshot-2024-03-05-142415.png",
    link: "https://github.com/amaz11/messenger_frontend",
  },
  {
    title: "E-commerce Web Application (Next JS 14)",
    subtitle: "Next js 14, React Js with Typescript, Prisma, MySql",
    description:
      "Developed a fully responsive e-commerce web application using Next.js 14. Implemented user authentication and authorization. Created a dynamic shopping basket system. Achieved seamless communication between front-end and back-end through RESTful API design. Ensured scalability and ease of maintenance for future feature additions.",
    image: "https://i.ibb.co/19KML19/Screenshot-2024-06-09-143103.png",
    link: "https://github.com/amaz11/macroll_pizza",
  },
   {
    title: "Dashboard Template Design",
    subtitle: "React Js, Sass",
    description:
      "Created a responsive dashboard template using React Js and Sass. Implemented features allowing one-click conversion of the sidebar to the top bar. Provided options for left and right orientation of the dashboard. Enabled users to change the orientation of the webpage by clicking the direction button.",
    image: "https://i.ibb.co/X5f3nRj/Screenshot-2024-06-09-143247.png",
    link: "https://github.com/amaz11/tesla_fake_clone",
  },
  {
    title: "Instragram Clone",
    subtitle: "MERN Stack",
    description:
      "Developed a Full Stack Web Application. Implemented features for users to upload, read, and delete posts. Enabled users to comment on posts for enhanced engagement. Included functionality for users to follow and unfollow other users.",
    image: "https://i.ibb.co/88Wz6y5/Screenshot-2024-06-09-143856.png",
    link: "https://github.com/amaz11/instragram-clone_frontend",
  },
];

export const skills = ["JavaScript", "React", "Next.js", "Node", "Material UI", "Redux Toolkit", "Redux RTK Queary"];
export const testimonials = [
  {
    quote:
      "K M Amaz Uddin and I worked together on several projects, and I was lucky to call him my coworker. He consistently gave full effort to the team and played a significant role in ensuring that we completed assignments on time. ",
    image:
      "https://media.licdn.com/dms/image/C4D03AQH6UmrLRL9hOw/profile-displayphoto-shrink_200_200/0/1656320892768?e=1692230400&v=beta&t=rxfaX_N6vyIodiLKaJ2XFJxvJaQZTBWpEan7ronpVV0",
    name: "Md.Orun sunny",
    company: "Selopia",
  },
  // {
  //   quote:
  //     "Lorem ipsum dolor sit amet consectetur adipisicing elit. Culpa quod necessitatibus quidem impedit facilis? Distinctio laboriosam veritatis recusandae minus. Voluptatum accusantium hic laudantium soluta ea sapiente cupiditate officia maiores itaque.",
  //   image: "https://randomuser.me/api/portraits/men/94.jpg",
  //   name: "Ruben Alvarez",
  //   company: "Dooble.io",
  // },
];
